<div class="overlay">
  @if (chartId === 'arat') {
    <div class="top-left">
      <select class="schrift" id="seite" (change)="onSubTypeDropDownSelect($event)">
        <option value="all">Gesamtscore</option>
        <!-- <option value="both">▲ links und ◼ rechts</option> -->
        <option value="grasp">1. Greifen</option>
        <option value="grip">2. Griff</option>
        <option value="pinch">3. Präzisionsgriff</option>
        <option value="gross">4. Basale Armbewegung</option>
      </select>
      <div class="top-center">
        <div>
          <app-point-style [side]="'links'"></app-point-style><span class="schrift">links</span>
          <span class="gap"></span>
          <app-point-style [side]="'rechts'"></app-point-style><span class="schrift">rechts</span>
        </div>
      </div>
    </div>
  } @else {
    <div class="top-left">
      <div class="top-center">
        <div>
          <app-point-style [side]="'links'"></app-point-style><span class="schrift">links</span>
          <span class="gap"></span>
          <app-point-style [side]="'rechts'"></app-point-style><span class="schrift">rechts</span>
        </div>
      </div>
    </div>
  }

  <div class="top-right">
    <span class="schrift">Erfüllung</span>
  </div>
</div>

<canvas style="width: 100%" #canvas [id]="chartId">{{ chart }}</canvas>
